'use strict';

var React = require('react');

var SvgThumbsUpMinor = function SvgThumbsUpMinor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6.685 6a4 4 0 0 0 .911-1.193l.695-1.39a2.563 2.563 0 0 1 2.293-1.417h.709a1.707 1.707 0 0 1 1.707 1.707v2.293h1.405a3 3 0 0 1 2.952 3.537l-.91 5a3 3 0 0 1-2.949 2.463h-2.094a4 4 0 0 1-2.499-.877l-2.655-2.123h-2.25a1 1 0 0 1-1-1v-6a1 1 0 0 1 1-1h2.685Zm3.9-2h.415v4h3.405a1 1 0 0 1 .984 1.179l-.909 5a1 1 0 0 1-.984.821h-2.093a2 2 0 0 1-1.25-.438l-3.153-2.523v-3.814a6 6 0 0 0 2.385-2.523l.695-1.39a.564.564 0 0 1 .504-.312Z"
  }));
};

exports.SvgThumbsUpMinor = SvgThumbsUpMinor;
